import { PAYMENT_METHOD_CREDIT_CARD, PAYMENT_METHOD_PAYPAL, PAYMENT_METHOD_ALIPAY, PAYMENT_METHOD_BANK_TRANSFER, PAYMENT_METHOD_KLARNA_PAY_NOW, PAYMENT_METHOD_KLARNA_PAY_LATER, PAYMENT_METHOD_POLI, PAYMENT_METHOD_BANCONTACT_MOBILE, PAYMENT_METHOD_DEBIT_CARDS, PAYMENT_METHOD_IDEAL, PAYMENT_METHOD_CC_VISA, PAYMENT_METHOD_CC_MASTERCARD, PAYMENT_METHOD_CC_AMEX, PAYMENT_METHOD_CC_DINERS, PAYMENT_METHOD_CC_UATP, PAYMENT_METHOD_CC_HIPERCARD, PAYMENT_METHOD_CC_ELO, PAYMENT_METHOD_CC_CARTES_BANCAIRES, PAYMENT_METHOD_DC_BANCONTACT, PAYMENT_METHOD_CC_DISCOVERCARD, PAYMENT_METHOD_DC_VISA_DEBIT, PAYMENT_METHOD_DC_MASTERCARD_DEBIT, PAYMENT_METHOD_DC_MAESTRO, PAYMENT_METHOD_PRP, PAYMENT_METHOD_PRP_MB_WAY, PAYMENT_METHOD_PRP_ATM, TRANSLATION_FOPS, PAYMENT_METHOD_CREDIT_CARDS, PAYMENT_METHOD_MULTICAIXA, PAYMENT_METHOD_PICKUP, COUNTRY_CODE_CAPE_VERDE, COUNTRY_CODE_IVORY_COAST, COUNTRY_CODE_GHANA, COUNTRY_CODE_GUINEA_BISSAU, COUNTRY_CODE_MOZAMBIQUE, COUNTRY_CODE_SAO_TOME, COUNTRY_CODE_SENEGAL, COUNTRY_CODE_TOGO, COUNTRY_CODE_MOROCCO, PAYMENT_METHOD_BANK_TRANSFER_BR, PAYMENT_METHOD_LOTERIAS, PAYMENT_METHOD_SAFETYPAY, PAYMENT_METHOD_REVOLUT, PAYMENT_METHOD_MULTICAIXA_EXPRESS } from '@ibe.config';
import { INDRAIbeAdminService } from './ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import * as i0 from "@angular/core";
import * as i1 from "./ibeadmin.indra.service";
import * as i2 from "./bfm-data-storage.indra.service";
import * as i3 from "./date.indra.service";
import * as i4 from "./ibeadmin-config.service";
var INDRABookingPaymentService = /** @class */ (function () {
    function INDRABookingPaymentService(ibeAdminService, bfmStorage, dateService, ibeAdminConfigService) {
        this.ibeAdminService = ibeAdminService;
        this.bfmStorage = bfmStorage;
        this.dateService = dateService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.translation = TRANSLATION_FOPS;
    }
    INDRABookingPaymentService.prototype.INDRA_generateFOPs = function (fops) {
        var _this = this;
        var generatedFOPs = [];
        fops.forEach(function (fop) {
            var newFOP = _this.INDRA_getFOP(fop);
            var existing = generatedFOPs.find(function (f) { return f.fopIconName == newFOP.fopIconName; });
            if (!existing) {
                generatedFOPs.push(newFOP);
            }
        });
        return generatedFOPs;
    };
    INDRABookingPaymentService.prototype.INDRA_getFOP = function (fop) {
        var fopIconNamePrefix = 'payment_method';
        var fopIconName = '';
        switch (fop.paymentMethodCode) {
            case PAYMENT_METHOD_CREDIT_CARD:
                fopIconNamePrefix = 'credit_card';
                switch (fop.fopCode) {
                    case PAYMENT_METHOD_CC_VISA:
                    case PAYMENT_METHOD_DC_VISA_DEBIT:
                        fopIconName = 'visa';
                        break;
                    case PAYMENT_METHOD_CC_MASTERCARD:
                    case PAYMENT_METHOD_DC_MASTERCARD_DEBIT:
                        fopIconName = 'mastercard';
                        break;
                    case PAYMENT_METHOD_CC_AMEX:
                        fopIconName = 'american_express';
                        break;
                    case PAYMENT_METHOD_CC_DINERS:
                        fopIconName = 'diners_club';
                        break;
                    case PAYMENT_METHOD_CC_UATP:
                        fopIconName = 'uatp';
                        break;
                    case PAYMENT_METHOD_CC_HIPERCARD:
                        fopIconName = 'hipercard';
                        break;
                    case PAYMENT_METHOD_CC_ELO:
                        fopIconName = 'elo';
                        break;
                    case PAYMENT_METHOD_CC_CARTES_BANCAIRES:
                        fopIconName = 'carte_bleue';
                        break;
                    case PAYMENT_METHOD_DC_MAESTRO:
                        fopIconName = 'maestro';
                        break;
                    case PAYMENT_METHOD_CC_DISCOVERCARD:
                        fopIconName = 'discover';
                        break;
                    case PAYMENT_METHOD_DC_BANCONTACT:
                        fopIconName = 'bancontact';
                        fopIconNamePrefix = 'payment_method';
                        break;
                }
                break;
            case PAYMENT_METHOD_PAYPAL:
                fopIconName = 'paypal';
                break;
            case PAYMENT_METHOD_ALIPAY:
                fopIconName = 'alipay';
                break;
            case PAYMENT_METHOD_BANK_TRANSFER:
                fopIconName = 'bank_transfer';
                break;
            case PAYMENT_METHOD_KLARNA_PAY_NOW:
                fopIconName = 'klarna';
                break;
            case PAYMENT_METHOD_KLARNA_PAY_LATER:
                fopIconName = 'klarna';
                break;
            case PAYMENT_METHOD_REVOLUT:
                fopIconName = 'revolut';
                break;
            case PAYMENT_METHOD_POLI:
                fopIconName = 'poli';
                break;
            case PAYMENT_METHOD_IDEAL:
                fopIconName = 'ideal';
                break;
            case PAYMENT_METHOD_BANCONTACT_MOBILE:
                fopIconName = 'bancontact';
                break;
            case PAYMENT_METHOD_PRP:
                switch (fop.fopCode) {
                    case PAYMENT_METHOD_PRP_MB_WAY:
                        fopIconName = 'mb_way';
                        break;
                    case PAYMENT_METHOD_PRP_ATM:
                        fopIconName = 'multibanco';
                        break;
                }
                break;
            case PAYMENT_METHOD_MULTICAIXA:
                fopIconName = 'multicaixa';
                break;
            case PAYMENT_METHOD_MULTICAIXA_EXPRESS:
                fopIconName = 'multicaixa_express';
                break;
            case PAYMENT_METHOD_PICKUP:
                fopIconName = 'pickup';
                break;
            case PAYMENT_METHOD_SAFETYPAY:
                fopIconName = 'safety_pay';
                switch (fop.fopCode) {
                    case PAYMENT_METHOD_BANK_TRANSFER_BR:
                        fopIconName = 'bank_transfer';
                        break;
                    case PAYMENT_METHOD_LOTERIAS:
                        fopIconName = 'caixa_loterias';
                        break;
                }
                break;
            /*
            // icons with no actual payment method codes yet
            case '':
                fopIconName = 'mb_way';
                break;
            case '':
                fopIconName = 'safety_pay';
                break;
            case '':
                fopIconName = 'caixa_loterias';
                break;
            */
        }
        var fopName = fop.fopName;
        var tooltip = this.ibeAdminService.getTranslationValue(this.translation.MODULE + "." + this.translation.KEY1 + "." + this.translation.KEY2 + "." + fopName.replace(/\s/g, '').toLowerCase());
        var fopTooltip = tooltip.includes(this.translation.MODULE + "." + this.translation.KEY1 + "." + this.translation.KEY2) ? fopName : tooltip; // check if tooltip translation is existing, show fop name otherwise
        var fopIconSVG = fopIconName ? "sprite.svg#" + fopIconNamePrefix + "--" + fopIconName : 'sprite.svg#payment_method--credit_card'; // check if fop is handled, show card icon otherwise
        var paymentMethod = {
            paymentMethodCode: fop.paymentMethodCode,
            paymentMethodName: fop.paymentMethodName,
            fopCode: fop.fopCode,
            fopName: fopName,
            fopTooltip: fopTooltip,
            fopIconName: fopIconName,
            fopIconSVG: fopIconSVG
        };
        return paymentMethod;
    };
    INDRABookingPaymentService.prototype.INDRA_getPaymentMethodIconName = function (paymentMethodCode, fopCode) {
        var fopIconName;
        switch (paymentMethodCode) {
            case PAYMENT_METHOD_CREDIT_CARD:
                if (PAYMENT_METHOD_CREDIT_CARDS.includes(fopCode)) {
                    fopIconName = 'credit_card';
                }
                // added to be able to show bancontact as a separate payment method
                if (fopCode === PAYMENT_METHOD_DC_BANCONTACT) {
                    fopIconName = 'bancontact';
                }
                if (PAYMENT_METHOD_DEBIT_CARDS.includes(fopCode)) {
                    fopIconName = fopIconName ? [fopIconName, 'debit_card'] : 'debit_card';
                }
                break;
            case PAYMENT_METHOD_PAYPAL:
                fopIconName = 'paypal';
                break;
            case PAYMENT_METHOD_ALIPAY:
                fopIconName = 'alipay';
                break;
            case PAYMENT_METHOD_BANK_TRANSFER:
                fopIconName = 'bank_transfer';
                break;
            case PAYMENT_METHOD_KLARNA_PAY_NOW:
                fopIconName = 'klarna_pay_now';
                break;
            case PAYMENT_METHOD_KLARNA_PAY_LATER:
                fopIconName = 'klarna_pay_later';
                break;
            case PAYMENT_METHOD_REVOLUT:
                fopIconName = 'revolut';
                break;
            case PAYMENT_METHOD_POLI:
                fopIconName = 'poli';
                break;
            case PAYMENT_METHOD_PRP:
                if (fopCode === PAYMENT_METHOD_PRP_MB_WAY) {
                    fopIconName = 'mb_way';
                }
                else {
                    fopIconName = 'multibanco';
                }
                break;
            case PAYMENT_METHOD_IDEAL:
                fopIconName = 'ideal';
                break;
            case PAYMENT_METHOD_MULTICAIXA:
                fopIconName = 'multicaixa';
                break;
            case PAYMENT_METHOD_MULTICAIXA_EXPRESS:
                fopIconName = 'multicaixa_express';
                break;
            case PAYMENT_METHOD_PICKUP:
                fopIconName = 'pickup';
                break;
            case PAYMENT_METHOD_SAFETYPAY:
                fopIconName = 'safety_pay';
                switch (fopCode) {
                    case PAYMENT_METHOD_BANK_TRANSFER_BR:
                        fopIconName = 'bank_transfer_br';
                        break;
                    case PAYMENT_METHOD_LOTERIAS:
                        fopIconName = 'caixa_loterias';
                        break;
                }
                break;
            /* note: commented out since according to the client this FOP is invalid
            case PAYMENT_METHOD_BANCONTACT_MOBILE:
                fopIconName = 'bancontact';
                break;
            */
            /*
        // icons with no actual payment method codes yet
        case '':
            fopIconName = 'safety_pay';
            break;
        case '':
            fopIconName = 'caixa_loterias';
            break;
        
        */
        }
        return fopIconName;
    };
    INDRABookingPaymentService.prototype.INDRA_getPaymentMethodCards = function (fopList, cardType, enabled) {
        if (!fopList || !fopList.length || fopList.length === 0) {
            return;
        }
        var fopCardList = [];
        fopList.forEach(function (fop) {
            if (fop.enable === enabled) {
                var cardFOP = void 0;
                switch (cardType) {
                    case 'debit':
                        switch (fop.fopCode) {
                            case PAYMENT_METHOD_DC_VISA_DEBIT:
                                cardFOP = 'visa';
                                break;
                            case PAYMENT_METHOD_DC_MAESTRO:
                                cardFOP = 'maestro';
                                break;
                            case PAYMENT_METHOD_DC_MASTERCARD_DEBIT:
                                cardFOP = 'mastercard';
                                break;
                            case PAYMENT_METHOD_DC_BANCONTACT:
                                cardFOP = 'bancontact';
                                break;
                            default: break;
                        }
                    case 'credit':
                        switch (fop.fopCode) {
                            case PAYMENT_METHOD_CC_VISA:
                                cardFOP = 'visa';
                                break;
                            case PAYMENT_METHOD_CC_MASTERCARD:
                                cardFOP = 'mastercard';
                                break;
                            case PAYMENT_METHOD_CC_AMEX:
                                cardFOP = 'amex';
                                break;
                            case PAYMENT_METHOD_CC_DINERS:
                                cardFOP = 'diners_club';
                                break;
                            case PAYMENT_METHOD_CC_UATP:
                                cardFOP = 'uatp';
                                break;
                            case PAYMENT_METHOD_CC_HIPERCARD:
                                cardFOP = 'hipercard';
                                break;
                            case PAYMENT_METHOD_CC_ELO:
                                cardFOP = 'elo';
                                break;
                            case PAYMENT_METHOD_CC_DISCOVERCARD:
                                cardFOP = 'discover';
                                break;
                            case PAYMENT_METHOD_CC_CARTES_BANCAIRES:
                                cardFOP = 'carte_bleue';
                                break;
                            default: break;
                        }
                    default: break;
                }
                if (fopCardList.indexOf(cardFOP) < 0) {
                    fopCardList.push(cardFOP);
                }
            }
        });
        return fopCardList;
    };
    INDRABookingPaymentService.prototype.INDRA_getFOPLabelTranslationKey = function (fopName) {
        if (!fopName)
            return;
        return this.translation.MODULE + "." + this.translation.LABEL_KEY + "." + this.translation.KEY2 + "." + fopName.replace(/[_-]/g, '').toLowerCase();
    };
    INDRABookingPaymentService.prototype.INDRA_getPaymentMethodParamValues = function (paymentMethodParamName, fopCode) {
        var paramsValue = null;
        var paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
        if (paymentMethod && paymentMethod.data && paymentMethod.data.fops && paymentMethod.data.fops.length > 0) {
            var fopList = paymentMethod.data.fops;
            var fop = fopList.find(function (fop) { return fop.fopCode === fopCode; });
            if (fop && fop.params && fop.params.length > 0) {
                var paymentMethodParam = fop.params.filter(function (el) { return el.paramCode === paymentMethodParamName; });
                paramsValue = (paymentMethodParam && paymentMethodParam.length > 0) ? paymentMethodParam[0].paramValue : null;
            }
        }
        return paramsValue;
    };
    INDRABookingPaymentService.prototype.INDRA_getApplicableReservationValidity = function (bookedTrip, fop) {
        var validity = 0;
        if (bookedTrip) {
            var departureDate = bookedTrip.data.fare.listOutbound[0].listSegment[0].departureDate.toString();
            var remainingHours = this.dateService.INDRA_getRemainingTimeInHours(departureDate);
            switch (fop) {
                case PAYMENT_METHOD_PRP_ATM:
                    if (remainingHours > 72) {
                        validity = 18;
                    }
                    else if (remainingHours <= 72 && remainingHours > 24) {
                        validity = 6;
                    }
                    else if (remainingHours <= 24) {
                        validity = 3;
                    }
                    break;
                case PAYMENT_METHOD_MULTICAIXA:
                    if (remainingHours > 72) {
                        validity = 48;
                    }
                    else if (remainingHours <= 72 && remainingHours > 48) {
                        validity = 24;
                    }
                    else if (remainingHours <= 48 && remainingHours >= 3) {
                        validity = 12;
                    }
                    break;
                default: break;
            }
        }
        return validity;
    };
    INDRABookingPaymentService.prototype.INDRA_getBankTransferInfoPaybyrd = function (market) {
        var BANK_TRANSFER_PREFIX = 'bookingPayment.bankTransfer';
        var EMAIL = 'email';
        var EXCHANGE_RATE = 'exchangeRateText';
        var bankTransferInfo;
        bankTransferInfo = {
            market: market,
            email: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, BANK_TRANSFER_PREFIX, EMAIL)),
            exchangeRate: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, BANK_TRANSFER_PREFIX, EXCHANGE_RATE)),
            bankTransferDetails: this.setBankTransferAccDetailsPaybyrd(market, BANK_TRANSFER_PREFIX)
        };
        return bankTransferInfo;
    };
    INDRABookingPaymentService.prototype.setBankTransferAccDetailsPaybyrd = function (market, prefix) {
        var BANK_NAME = 'bankName';
        var NIB = 'nib';
        var IBAN = 'iban';
        var SWIFT = 'swift';
        var ACCOUNT_NUMBER = 'bankAccountNumber';
        var ADDRESS = 'bankAddress';
        var OPTION_PRIMARY = 'primary';
        var OPTION_SECONDARY = 'secondary';
        var primary_name = this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, BANK_NAME, OPTION_PRIMARY));
        var secondary_name = this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, BANK_NAME, OPTION_SECONDARY));
        var bankTransferDetailsArray = [];
        // Check bank_transfer name on ibeAdmin if it's exist on the current market. If primary_name return  ibeAdmin key meaning it is not exist on ibeAdmin.
        if (primary_name.indexOf("bookingPayment.bankTransfer") === -1) {
            var bankDetails = {
                name: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, BANK_NAME, OPTION_PRIMARY)),
                nib: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, NIB, OPTION_PRIMARY)),
                iban: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, IBAN, OPTION_PRIMARY)),
                swift: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, SWIFT, OPTION_PRIMARY)),
                accountNumber: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, ACCOUNT_NUMBER, OPTION_PRIMARY)),
                address: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, ADDRESS, OPTION_PRIMARY))
            };
            bankTransferDetailsArray.push(bankDetails);
        }
        if (secondary_name.indexOf("bookingPayment.bankTransfer") === -1) {
            var bankDetails = {
                name: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, BANK_NAME, OPTION_SECONDARY)),
                nib: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, NIB, OPTION_SECONDARY)),
                iban: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, IBAN, OPTION_SECONDARY)),
                swift: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, SWIFT, OPTION_SECONDARY)),
                accountNumber: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, ACCOUNT_NUMBER, OPTION_SECONDARY)),
                address: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, ADDRESS, OPTION_SECONDARY))
            };
            bankTransferDetailsArray.push(bankDetails);
        }
        return bankTransferDetailsArray;
    };
    INDRABookingPaymentService.prototype.INDRA_getBankTransferInformation = function (market) {
        var BANK_TRANSFER_PREFIX = 'bookingPayment.bankTransfer';
        var EMAIL = 'email';
        var EXCHANGE_RATE = 'exchangeRateText';
        var bankDetailsCount = 1;
        switch (market) {
            case COUNTRY_CODE_CAPE_VERDE:
                bankDetailsCount = 2;
                break;
            case COUNTRY_CODE_IVORY_COAST:
                bankDetailsCount = 1;
                break;
            case COUNTRY_CODE_GHANA:
                bankDetailsCount = 2;
                break;
            case COUNTRY_CODE_GUINEA_BISSAU:
                bankDetailsCount = 1;
                break;
            case COUNTRY_CODE_MOZAMBIQUE:
                bankDetailsCount = 1;
                break;
            case COUNTRY_CODE_SAO_TOME:
                bankDetailsCount = 1;
                break;
            case COUNTRY_CODE_SENEGAL:
                bankDetailsCount = 1;
                break;
            case COUNTRY_CODE_TOGO:
                bankDetailsCount = 1;
                break;
            case COUNTRY_CODE_MOROCCO:
                bankDetailsCount = 1;
                break;
            default:
                bankDetailsCount = 0;
                break;
        }
        var bankTransferInfo;
        if (bankDetailsCount > 0) {
            bankTransferInfo = {
                market: market,
                email: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, BANK_TRANSFER_PREFIX, EMAIL)),
                exchangeRate: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, BANK_TRANSFER_PREFIX, EXCHANGE_RATE)),
                bankTransferDetails: this.setBankTransferAccountDetails(market, bankDetailsCount, BANK_TRANSFER_PREFIX)
            };
        }
        return bankTransferInfo;
    };
    INDRABookingPaymentService.prototype.setBankTransferAccountDetails = function (market, bankDetailsCount, prefix) {
        var BANK_NAME = 'bankName';
        var NIB = 'nib';
        var IBAN = 'iban';
        var SWIFT = 'swift';
        var ACCOUNT_NUMBER = 'bankAccountNumber';
        var ADDRESS = 'bankAddress';
        var OPTION_PRIMARY = 'primary';
        var OPTION_SECONDARY = 'secondary';
        var bankTransferDetailsArray = [];
        for (var index = 1; index <= bankDetailsCount; index++) {
            var option = index == 1 ? OPTION_PRIMARY : OPTION_SECONDARY;
            var bankDetails = {
                name: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, BANK_NAME, option)),
                nib: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, NIB, option)),
                iban: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, IBAN, option)),
                swift: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, SWIFT, option)),
                accountNumber: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, ACCOUNT_NUMBER, option)),
                address: this.ibeAdminConfigService.getConfigurationValue(this.constructBankTransferConfigurationKey(market, prefix, ADDRESS, option))
            };
            bankTransferDetailsArray.push(bankDetails);
        }
        return bankTransferDetailsArray;
    };
    INDRABookingPaymentService.prototype.constructBankTransferConfigurationKey = function (market, configurationPrefix, configurationProperty, configurationIndex) {
        if (configurationIndex === void 0) { configurationIndex = null; }
        return (configurationIndex ? (configurationPrefix + '.' + market + '.' + configurationIndex + '.' + configurationProperty) :
            (configurationPrefix + '.' + market + '.' + configurationProperty));
    };
    INDRABookingPaymentService.prototype.INDRA_getIdealBankIssuerList = function () {
        var bankIssuerList = [];
        var paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
        if (paymentMethod && paymentMethod.data && paymentMethod.data.iteamsAdyenBean && paymentMethod.data.iteamsAdyenBean.length > 0) {
            paymentMethod.data.iteamsAdyenBean.forEach(function (e) {
                bankIssuerList.push({ text: e.name, value: e.id });
            });
        }
        return bankIssuerList;
    };
    INDRABookingPaymentService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABookingPaymentService_Factory() { return new INDRABookingPaymentService(i0.inject(i1.INDRAIbeAdminService), i0.inject(i2.INDRABFMDataStorageService), i0.inject(i3.INDRADateService), i0.inject(i4.INDRAIbeAdminConfigService)); }, token: INDRABookingPaymentService, providedIn: "root" });
    return INDRABookingPaymentService;
}());
export { INDRABookingPaymentService };
